export default __webpack_public_path__ + "static/media/Perreo comabativo-hbf2.5b3616e4.jpg";